/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { PriceRequestAppliedRulesFragmentDoc } from './PriceRequestAppliedRulesFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IPriceRequestAppliedRulesQueryVariables = Types.Exact<{
  priceRequestId: Types.Scalars['ID']
}>

export type IPriceRequestAppliedRulesQuery = { __typename?: 'Query' } & {
  priceRequestAppliedRules?: Types.Maybe<
    { __typename?: 'PriceRequestAppliedRules' } & Pick<
      Types.IPriceRequestAppliedRules,
      'id' | 'priceRequestId'
    > & {
        priceRequestAppliedRulesMetadata?: Types.Maybe<
          { __typename?: 'PriceRequestAppliedRulesMetadata' } & Pick<
            Types.IPriceRequestAppliedRulesMetadata,
            | 'dsCostPremiumPct'
            | 'datType'
            | 'strategyChosen'
            | 'benchmarkRate'
            | 'finalManualCostAdjustmentPercent'
            | 'adjustedCostBasis'
            | 'multiStopBucketUsed'
            | 'isDoNotBid'
            | 'appliedCustomRules'
          > & {
              fuelSurchargeCalculation?: Types.Maybe<
                { __typename?: 'FuelSurchargeCalculation' } & Pick<
                  Types.IFuelSurchargeCalculation,
                  | 'fuelRpm'
                  | 'fuelMileageType'
                  | 'fuelRpmType'
                  | 'fuelMileage'
                  | 'calculatedFuelCost'
                >
              >
              appliedCostControlConfig?: Types.Maybe<
                { __typename?: 'CostControlConfig' } & Pick<
                  Types.ICostControlConfig,
                  | 'id'
                  | 'pickupRegion'
                  | 'deliveryRegion'
                  | 'costStrategy'
                  | 'controlOption'
                  | 'ruleType'
                  | 'rangeStart'
                  | 'rangeEnd'
                  | 'isDrop'
                >
              >
              appliedSpotBiddingRules?: Types.Maybe<
                Array<
                  { __typename?: 'SpotBiddingRule' } & Pick<
                    Types.ISpotBiddingRule,
                    | 'id'
                    | 'ruleAction'
                    | 'reason'
                    | 'spotBiddingConfigId'
                    | 'shipperApplicationId'
                    | 'isBaseline'
                    | 'isWeekend'
                    | 'isSameDay'
                    | 'isMultiStop'
                    | 'isDrop'
                    | 'parentEquipmentKey'
                  > & {
                      geographicCriteria?: Types.Maybe<
                        { __typename?: 'GeographicCriteria' } & Pick<
                          Types.IGeographicCriteria,
                          'id' | 'criteriaType' | 'isInbound' | 'value'
                        >
                      >
                      dateCriteria?: Types.Maybe<
                        { __typename?: 'DateCriteria' } & Pick<
                          Types.IDateCriteria,
                          'id' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      transitDifferenceCriteria?: Types.Maybe<
                        { __typename?: 'TransitDifferenceCriteria' } & Pick<
                          Types.ITransitDifferenceCriteria,
                          'id' | 'timeUnit' | 'timeRangeStart' | 'timeRangeEnd'
                        >
                      >
                      carrierWaitTimeCriteria?: Types.Maybe<
                        { __typename?: 'CarrierWaitTimeCriteria' } & Pick<
                          Types.ICarrierWaitTimeCriteria,
                          'id' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      contractCriteria?: Types.Maybe<
                        { __typename?: 'ContractCriteria' } & Pick<
                          Types.IContractCriteria,
                          'id' | 'awardType'
                        >
                      >
                      countLoadsQuotedCriteria?: Types.Maybe<
                        { __typename?: 'CountLoadsQuotedCriteria' } & Pick<
                          Types.ICountLoadsQuotedCriteria,
                          | 'id'
                          | 'pickupType'
                          | 'pickupValue'
                          | 'deliveryType'
                          | 'deliveryValue'
                          | 'rangeStart'
                          | 'rangeEnd'
                          | 'isSamePickupDelivery'
                          | 'isDifferentPickupDelivery'
                        >
                      >
                      laneTierCriteria?: Types.Maybe<
                        { __typename?: 'LaneTierCriteria' } & Pick<
                          Types.ILaneTierCriteria,
                          'id' | 'tier'
                        >
                      >
                      distanceToMarketCenterCriteria?: Types.Maybe<
                        { __typename?: 'DistanceToMarketCenterCriteria' } & Pick<
                          Types.IDistanceToMarketCenterCriteria,
                          'id' | 'locationType' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      mileageCriteria?: Types.Maybe<
                        { __typename?: 'MileageCriteria' } & Pick<
                          Types.IMileageCriteria,
                          'id' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      appointmentTimeCriteria?: Types.Maybe<
                        { __typename?: 'AppointmentTimeCriteria' } & Pick<
                          Types.IAppointmentTimeCriteria,
                          | 'id'
                          | 'pickupRangeStart'
                          | 'pickupRangeEnd'
                          | 'deliveryRangeStart'
                          | 'deliveryRangeEnd'
                          | 'timezoneOverride'
                        >
                      >
                      stopSpecificDropCriteria?: Types.Maybe<
                        { __typename?: 'StopSpecificDropCriteria' } & Pick<
                          Types.IStopSpecificDropCriteria,
                          | 'id'
                          | 'showStopSpecificCheckbox'
                          | 'pickupDropTrailer'
                          | 'deliveryDropTrailer'
                        >
                      >
                      laneGeographicCriteria?: Types.Maybe<
                        { __typename?: 'LaneGeographicCriteria' } & Pick<
                          Types.ILaneGeographicCriteria,
                          'id' | 'pickupType' | 'pickupValue' | 'deliveryType' | 'deliveryValue'
                        >
                      >
                      proximalHourCriteria?: Types.Maybe<
                        { __typename?: 'ProximalHourCriteria' } & Pick<
                          Types.IProximalHourCriteria,
                          'id' | 'dayOrHour' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      ruleStartTimeCriteria?: Types.Maybe<
                        { __typename?: 'RuleStartTimeCriteria' } & Pick<
                          Types.IRuleStartTimeCriteria,
                          'id' | 'rangeStart'
                        >
                      >
                      spotPremium?: Types.Maybe<
                        { __typename?: 'SpotPremium' } & Pick<
                          Types.ISpotPremium,
                          'id' | 'premiumType' | 'amount'
                        >
                      >
                      spotBiddingConfig?: Types.Maybe<
                        { __typename?: 'SpotBiddingConfig' } & Pick<
                          Types.ISpotBiddingConfig,
                          'id' | 'namespace' | 'fuelRpm' | 'configType' | 'configName'
                        >
                      >
                    }
                >
              >
              appliedStrikePriceRules?: Types.Maybe<
                Array<
                  { __typename?: 'SpotBiddingRule' } & Pick<
                    Types.ISpotBiddingRule,
                    | 'id'
                    | 'ruleAction'
                    | 'reason'
                    | 'spotBiddingConfigId'
                    | 'shipperApplicationId'
                    | 'isBaseline'
                    | 'isWeekend'
                    | 'isSameDay'
                    | 'isMultiStop'
                    | 'isDrop'
                    | 'parentEquipmentKey'
                  > & {
                      geographicCriteria?: Types.Maybe<
                        { __typename?: 'GeographicCriteria' } & Pick<
                          Types.IGeographicCriteria,
                          'id' | 'criteriaType' | 'isInbound' | 'value'
                        >
                      >
                      dateCriteria?: Types.Maybe<
                        { __typename?: 'DateCriteria' } & Pick<
                          Types.IDateCriteria,
                          'id' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      transitDifferenceCriteria?: Types.Maybe<
                        { __typename?: 'TransitDifferenceCriteria' } & Pick<
                          Types.ITransitDifferenceCriteria,
                          'id' | 'timeUnit' | 'timeRangeStart' | 'timeRangeEnd'
                        >
                      >
                      carrierWaitTimeCriteria?: Types.Maybe<
                        { __typename?: 'CarrierWaitTimeCriteria' } & Pick<
                          Types.ICarrierWaitTimeCriteria,
                          'id' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      contractCriteria?: Types.Maybe<
                        { __typename?: 'ContractCriteria' } & Pick<
                          Types.IContractCriteria,
                          'id' | 'awardType'
                        >
                      >
                      countLoadsQuotedCriteria?: Types.Maybe<
                        { __typename?: 'CountLoadsQuotedCriteria' } & Pick<
                          Types.ICountLoadsQuotedCriteria,
                          | 'id'
                          | 'pickupType'
                          | 'pickupValue'
                          | 'deliveryType'
                          | 'deliveryValue'
                          | 'rangeStart'
                          | 'rangeEnd'
                          | 'isSamePickupDelivery'
                          | 'isDifferentPickupDelivery'
                        >
                      >
                      laneTierCriteria?: Types.Maybe<
                        { __typename?: 'LaneTierCriteria' } & Pick<
                          Types.ILaneTierCriteria,
                          'id' | 'tier'
                        >
                      >
                      distanceToMarketCenterCriteria?: Types.Maybe<
                        { __typename?: 'DistanceToMarketCenterCriteria' } & Pick<
                          Types.IDistanceToMarketCenterCriteria,
                          'id' | 'locationType' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      mileageCriteria?: Types.Maybe<
                        { __typename?: 'MileageCriteria' } & Pick<
                          Types.IMileageCriteria,
                          'id' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      appointmentTimeCriteria?: Types.Maybe<
                        { __typename?: 'AppointmentTimeCriteria' } & Pick<
                          Types.IAppointmentTimeCriteria,
                          | 'id'
                          | 'pickupRangeStart'
                          | 'pickupRangeEnd'
                          | 'deliveryRangeStart'
                          | 'deliveryRangeEnd'
                          | 'timezoneOverride'
                        >
                      >
                      stopSpecificDropCriteria?: Types.Maybe<
                        { __typename?: 'StopSpecificDropCriteria' } & Pick<
                          Types.IStopSpecificDropCriteria,
                          | 'id'
                          | 'showStopSpecificCheckbox'
                          | 'pickupDropTrailer'
                          | 'deliveryDropTrailer'
                        >
                      >
                      laneGeographicCriteria?: Types.Maybe<
                        { __typename?: 'LaneGeographicCriteria' } & Pick<
                          Types.ILaneGeographicCriteria,
                          'id' | 'pickupType' | 'pickupValue' | 'deliveryType' | 'deliveryValue'
                        >
                      >
                      proximalHourCriteria?: Types.Maybe<
                        { __typename?: 'ProximalHourCriteria' } & Pick<
                          Types.IProximalHourCriteria,
                          'id' | 'dayOrHour' | 'rangeStart' | 'rangeEnd'
                        >
                      >
                      ruleStartTimeCriteria?: Types.Maybe<
                        { __typename?: 'RuleStartTimeCriteria' } & Pick<
                          Types.IRuleStartTimeCriteria,
                          'id' | 'rangeStart'
                        >
                      >
                      spotPremium?: Types.Maybe<
                        { __typename?: 'SpotPremium' } & Pick<
                          Types.ISpotPremium,
                          'id' | 'premiumType' | 'amount'
                        >
                      >
                      spotBiddingConfig?: Types.Maybe<
                        { __typename?: 'SpotBiddingConfig' } & Pick<
                          Types.ISpotBiddingConfig,
                          'id' | 'namespace' | 'fuelRpm' | 'configType' | 'configName'
                        >
                      >
                    }
                >
              >
              additionalStops?: Types.Maybe<
                Array<
                  { __typename?: 'AdditionalStops' } & Pick<
                    Types.IAdditionalStops,
                    | 'city'
                    | 'startDate'
                    | 'startTime'
                    | 'postalCode'
                    | 'stateCode'
                    | 'isoCountryCode'
                  >
                >
              >
              multiStopLegDatObjects?: Types.Maybe<
                Array<
                  { __typename?: 'MultiStopLegDatObjects' } & Pick<
                    Types.IMultiStopLegDatObjects,
                    'pickupPostalCode' | 'deliveryPostalCode' | 'miles' | 'estimatedAllInTotal'
                  >
                >
              >
            }
        >
      }
  >
}

export const PriceRequestAppliedRulesDocument = gql`
  query PriceRequestAppliedRules($priceRequestId: ID!) {
    priceRequestAppliedRules(priceRequestId: $priceRequestId) {
      ...PriceRequestAppliedRules
    }
  }
  ${PriceRequestAppliedRulesFragmentDoc}
`

/**
 * __usePriceRequestAppliedRulesQuery__
 *
 * To run a query within a React component, call `usePriceRequestAppliedRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceRequestAppliedRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceRequestAppliedRulesQuery({
 *   variables: {
 *      priceRequestId: // value for 'priceRequestId'
 *   },
 * });
 */
export function usePriceRequestAppliedRulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IPriceRequestAppliedRulesQuery,
    IPriceRequestAppliedRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPriceRequestAppliedRulesQuery, IPriceRequestAppliedRulesQueryVariables>(
    PriceRequestAppliedRulesDocument,
    options
  )
}
export function usePriceRequestAppliedRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IPriceRequestAppliedRulesQuery,
    IPriceRequestAppliedRulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IPriceRequestAppliedRulesQuery,
    IPriceRequestAppliedRulesQueryVariables
  >(PriceRequestAppliedRulesDocument, options)
}
export type PriceRequestAppliedRulesQueryHookResult = ReturnType<
  typeof usePriceRequestAppliedRulesQuery
>
export type PriceRequestAppliedRulesLazyQueryHookResult = ReturnType<
  typeof usePriceRequestAppliedRulesLazyQuery
>
export type PriceRequestAppliedRulesQueryResult = Apollo.QueryResult<
  IPriceRequestAppliedRulesQuery,
  IPriceRequestAppliedRulesQueryVariables
>
